/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Staatsangehoerigkeit2fullname2Inputs */



/**

* @param {_Field_Staatsangehoerigkeit2fullname2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_staatsangehoerigkeit2fullname2 = /** @type {((inputs?: _Field_Staatsangehoerigkeit2fullname2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Staatsangehoerigkeit2fullname2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Zweite Staatsangehörigkeit (Name)")
});
export { _field_staatsangehoerigkeit2fullname2 as "_field_staatsangehoerigkeit2FullName" }